import { render } from "./TableModal.vue?vue&type=template&id=ac1f865a&lang=pug"
import script from "./TableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TableModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__